import { Selector, createSelector } from '@reduxjs/toolkit';
import { tSharedAppState, userSharedSelectors } from 'common/modules/ReactShared';

const selectLesson: Selector<tSharedAppState, tSharedAppState['shared']['lesson']> = (
  state
) => state.shared.lesson;

const selectSortedTargetLangs: Selector<
  tSharedAppState,
  ReturnType<typeof userSharedSelectors.selectTargetLangs>
> = createSelector(
  [selectLesson, userSharedSelectors.selectTargetLangs],
  (lesson, targetLangs) =>
    [...targetLangs].sort(
      (a, b) =>
        Number(b.code === lesson.data?.languageCode) -
        Number(a.code === lesson.data?.languageCode)
    )
);

const userSelectors = {
  ...userSharedSelectors,
  selectSortedTargetLangs
};

export default userSelectors;
